import React from 'react';
import { Tooltip } from 'antd';

export const ChooseProgramButton = ({ handleClick, chooseProgramTitle, choosenProgram }) => {
    return <div
        style={{
            color: '#FFF',
            fontSize: '40px',
        }}
        onClick={handleClick}
        className='widget-button'
    >
        <Tooltip
            placement="top"
            title={chooseProgramTitle?.title + (choosenProgram?.length ? choosenProgram : '-')}
        >
            <span
                style={{ fontSize: 56, lineHeight: 0 }}
                className='montserrat500'
            >
                {choosenProgram?.length ? choosenProgram[0].toUpperCase() : '-'}
            </span>
        </Tooltip>
    </div>
}